import {commitMutation, graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';

const mutation = graphql`
	mutation updateRateMutation($input: UpdateRateInput!) {
		updateRate(input: $input) {
			rate {
				id
				rate
			}
		}
	}
`;

function getConfigs() {
	return [];
}

function getOptimisticResponse({id, rate}) {
	const obj = {
		id,
	};
	if (rate) {
		obj.rate = rate;
	}
	return {
		rate: obj,
	};
}

function commit(environment, input, onCompleted, onError) {
	Util.localStorageDeleteFincancialMap();
	tracking.trackEvent('Rate Updated');

	const {id, rate} = input;
	return commitMutation(environment, {
		mutation,
		variables: {
			input: {
				csrfToken: Util.getCsrfValue(),
				socketClientId: Util.getClientId(),
				id,
				rate,
			},
		},
		configs: getConfigs(),
		optimisticResponse: getOptimisticResponse(input),
		onCompleted,
		onError,
	});
}

export default {commit};
